import { GridOptions } from 'ag-grid-community';

import { NumericEditor } from '../../shared/configs/cell-editors/numeric-editor';

import { AgGridCustomRadioFilterComponent } from './../../shared/components/ag-grid-custom-radio-filter/ag-grid-custom-radio-filter.component';

export const ChannelMappingGridOptions :GridOptions = {
  rowModelType: 'serverSide',
  suppressCopyRowsToClipboard: true,
  pagination: true,
  cacheBlockSize: 100,
  maxBlocksInCache: 100,
  paginationPageSize: 100,
  domLayout: 'autoHeight',
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressRowGroups: true,
        },
      },
    ],
    defaultToolPanel: '',
  },
  components: {
    AgGridCustomRadioFilterComponent,
    NumericEditor,
  },
  defaultColDef: {
    resizable: true,
  },
  processCellForClipboard: (params) => {
    return typeof params.value === 'object'
      ? JSON.stringify(params.value)
      : params.value;
  },
};

export const PAUSE_BUFFER_QUANTITY :number = 2000000000;
